import React, { useState } from 'react'
import TabAndTileCards from '../TabAndTileCards'
import CourseCards from '../CourseCards'
import CategoryCards from '../CategoryCards'
import TeacherCards from '../TeacherCards'
import { CardListContainer } from './CardListStyle'
import DailyPlay from '../DailyPlay'
import NewJournals from '../JournalCards'
import GenericCards from '../GenericCards'
import DailyQuote from '../DailyQuote'
import CourseTutorialCards from '../CourseTutorialCards'
import AssessmentCards from '../AssessmentCards'
import { MyPlanCard } from '../MyPlanCards'
import ActivityPlanCard from '../ActivityPlan/ActivityPlanCard'

const CardList = (props) => {
  const { cardsType, cardsCategory } = props
  const [areTileItemsHovered, setAreTileItemsHovered] = useState(false)

  if (cardsType === 'course' && cardsCategory === 'tutorial') {
    return <CourseTutorialCards {...props} />
  }

  let renderedCards
  switch (cardsType) {
    case 'tabAndTile':
      renderedCards = <TabAndTileCards {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'course':
      renderedCards = <CourseCards {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'genre':
    case 'tag':
    case 'feeling':
    case 'technique':
    case 'category':
      renderedCards = <CategoryCards {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'dailyFeature':
      renderedCards = <DailyPlay {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'journal':
      renderedCards = <NewJournals {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'dailyQuote':
      renderedCards = <DailyQuote {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'teacher':
      renderedCards = <TeacherCards {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'assessment':
      renderedCards = <AssessmentCards {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'plan':
      renderedCards = <MyPlanCard {...props} areTileItemsHovered={areTileItemsHovered} />
      break
    case 'activity-plan':
      renderedCards = (
        <ActivityPlanCard
          {...props}
          areTileItemsHovered={areTileItemsHovered}
          categoryType={cardsCategory}
        />
      )
      break
    default:
      renderedCards = <GenericCards {...props} areTileItemsHovered={areTileItemsHovered} />
  }

  return (
    <CardListContainer
      onMouseEnter={() => setAreTileItemsHovered(true)}
      onMouseLeave={() => setAreTileItemsHovered(false)}
    >
      {renderedCards}
    </CardListContainer>
  )
}

export default CardList
